import React from 'react';
import { motion } from 'framer-motion';
import { HERO_CONTENT } from '../../utils/constants';
import { heroText, fadeInUp, staggerContainer } from '../../utils/animations';


const HeroSection = () => {
  const handleClick = (href) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-900 via-brand-800 to-neutral-900 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-15">
        <div className="absolute top-20 left-10 w-72 h-72 bg-brand-500 rounded-full blur-[120px]" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-brand-400 rounded-full blur-[150px]" />
      </div>

      <motion.div
        className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center"
        variants={staggerContainer}
        initial="hidden"
        animate="visible"
      >


        <motion.h1
          className="text-4xl sm:text-5xl lg:text-6xl text-white leading-tight mb-6"
          style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
          variants={heroText}
        >
          {HERO_CONTENT.headline}
        </motion.h1>

        <motion.p
          className="text-lg sm:text-xl text-neutral-300 max-w-2xl mx-auto mb-10 leading-relaxed"
          variants={fadeInUp}
        >
          {HERO_CONTENT.subtext}
        </motion.p>

        <motion.div
          className="flex flex-wrap justify-center gap-4"
          variants={fadeInUp}
        >
          {HERO_CONTENT.buttons.map((btn, i) => (
            <button
              key={i}
              onClick={() => handleClick(btn.href)}
              className={`px-6 py-3 rounded-lg font-medium text-sm transition-all duration-200 ${
                btn.variant === 'primary'
                  ? 'bg-brand-500 text-white hover:bg-brand-600 shadow-lg shadow-brand-500/25'
                  : btn.variant === 'secondary'
                  ? 'bg-brand-400 text-white hover:bg-brand-500 shadow-lg shadow-brand-400/25'
                  : 'border border-white/30 text-white hover:bg-white/10'
              }`}
            >
              {btn.label}
            </button>
          ))}
        </motion.div>
      </motion.div>

      {/* Scroll indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex justify-center pt-2">
          <div className="w-1.5 h-1.5 bg-white/60 rounded-full" />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;